import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import { observer } from 'mobx-react'
import { splitNumberDigits } from 'helpers/math'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import GroupSelector from './GroupSelector'
import { translate as loc, dict } from 'Localisation'
import DummyCounter from 'components/ContentBox/Global/Counter/DummyCounter'
import './AddPayment.scss'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormSelectCustom from 'components/UI/AsideModal/Form/FormSelectCustom'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import ToggleCheckbox from 'components/UI/ToggleCheckbox/ToggleCheckbox'
import FormDateSelector from 'components/UI/AsideModal/Form/FormDateSelector'
import asideModalStore from 'Stores/asideModalStore'
import Loader from 'components/UI/Loader/Loader'

const initValues = {
  payment_date: dateFormat(new Date(), 'YYYY-mm-dd'),
  // Дата действия счета (+2 дня)
  payment_expires: dateFormat(
    new Date(new Date().getTime() + 2 * 24 * 60 * 60 * 1000),
    'YYYY-mm-dd',
  ),
  price_sums: 1,
  bank: 1,
  hourType: 1,
  countWithDiscount: false,
  amount: 0,
  hours: 1,
  price_per_minute: 0,
  sum_discount: 0,
  status_sending_mail: 'need_mail',
  bonus_balance: 0,
}

const AddPayment = ({ groupId }) => {
  const {
    modalValues: data,
    values: valuesData,
    changeValues: changeValuesArray,
    check,
  } = asideModalStore

  const getModalValues = data

  const { isClient } = Stores

  const [values, setValues] = useState(initValues)
  const [payData, setPayData] = useState(false)
  const [fetchedPriceSums, setFetchedPricedSums] = useState([])
  const [loading, setLoading] = useState(false)

  const getResultPriceSums = (data) => {
    setFetchedPricedSums(data?.result)
    return data?.result
  }
  const changeHandler = (value, key) => {
    setValues({ ...values, [key]: value })
  }
  const calculator = (value, type, sgr) => {
    let obj = { ...values }
    switch (type) {
      case 'hours':
        obj.amount = Math.round(
          value *
            (values.hourType === 1 ? 45 : 60) *
            (values.countWithDiscount
              ? values.sum_discount
              : values.price_per_minute),
        ).toFixed(2)
        obj.hours = value
        break
      case 'price_sums':
        const sum =
          value.id === values.price_sums_with_discount
            ? values.sum_discount
            : value.price_per_minute
        obj.amount = Math.round(
          values.hours * (values.hourType === 1 ? 45 : 60) * sum,
        ).toFixed(2)
        obj.countWithDiscount = value.id === values.price_sums_with_discount
        obj.price_sums = value.id
        if (value.sum_discount) {
          // Only when selecting direction of payment
          obj.sum_discount = value.sum_discount
          obj.countWithDiscount = true
          obj.price_sums_with_discount = value.id
          obj.amount = Math.round(
            values.hours *
              (values.hourType === 1 ? 45 : 60) *
              value.sum_discount,
          ).toFixed(2)
        }
        obj.price_per_minute = value.price_per_minute
        if (sgr) {
          obj.student_group_rel = sgr
          delete obj.company
        }
        break
      case 'hourType':
        obj.amount = Math.round(
          values.hours *
            (value === 1 ? 45 : 60) *
            (values.countWithDiscount
              ? values.sum_discount
              : values.price_per_minute),
        ).toFixed(2)
        obj.hourType = value
        break
      case 'amount':
        obj.amount = +value
        if (values.price_per_minute > 0 && +value > 100)
          obj.hours =
            value / values.price_per_minute / (values.hourType === 1 ? 45 : 60)
        break
      default:
        break
    }
    setValues(obj)
  }

  const changeGroup = (data) => {
    if (data.student_group_rel > 1) {
      const ps = {
        ...data.default_price,
      }
      calculator(ps, 'price_sums', data.student_group_rel)
    } else {
      const bs = { ...values }
      bs.company = data.company.id
      bs.price_sums = 1
      bs.amount = 0
      bs.countWithDiscount = false
      delete bs.student_group_rel
      setValues({ ...bs })
    }
  }

  const formatOptionLabel = (opt, { context }) => {
    const str = `${opt.name} ${
      context === 'menu' ? '<br/>' : ''
    }(<b>${splitNumberDigits(opt.price_sum)}.00</b>тг. за ${opt.hours_sum} ${
      opt.hours_type.id === 1 ? 'ак.ч.' : 'астр.ч.'
    })`
    return <span dangerouslySetInnerHTML={{ __html: str }} />
  }

  useEffect(() => {
    let mount = true
    setLoading(true)
    superAxiosRequest({
      method: 'get',
      link: 'payments/pay_orders/info',
      params: {
        client_id: data?.client_id || valuesData?.user,
        hours_type: values.hourType,
      },
    })
      .then((res) => {
        if (!mount) return
        setPayData(res.data)
        if (getModalValues.student_group_rel) {
          const g = res.data.groups.find(
            (x) => x.id === getModalValues.student_group_rel,
          )
          if (g)
            setValues({
              ...values,
              student_group_rel: g.student_group_rel,
              price_sums: g.default_price.id,
              price_sums_with_discount: g.default_price.id,
              hours: 1,
              price_per_minute: g.default_price.price_per_minute,
              // amount:
              //   getModalValues.amount / 100 ||
              //   (g.default_price.price_per_minute * 45) / 100,
              sum_discount: +g.default_price.sum_discount,
              countWithDiscount: Boolean(g?.default_price),
            })
        }
        if (getModalValues.company) {
          const c = res.data.company_balances.find(
            (x) => x.company.id === +getModalValues.company,
          )
          if (c) setValues({ ...values, company: c.company.id, amount: 0 })
        }
        // Если ничего не выбрано, то выбираем первую группу, а если нет группы - первую компанию
        if (!getModalValues.student_group_rel && !getModalValues.company) {
          if (res.data.groups.length)
            setValues({
              ...values,
              student_group_rel: res.data.groups?.[0]?.student_group_rel,
            })
          else
            setValues({
              ...values,
              company: res.data.company_balances?.[0]?.company.id,
            })
        }
      })
      .finally(() => {
        setLoading(false)
      })

    return () => {
      mount = false
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    let bo = {
      payment_date: values.payment_date,
      payment_expires: values.payment_expires,
      ...(values.student_group_rel && {
        student_group_rel: values.student_group_rel,
      }),
      ...(values.company && { company: values.company }),
      ...(values.location && { location: values.location }),
      study_start: values.study_start,
      study_finish: values.study_finish,
      bank: values.bank,
      amount: values.bonus_balance
        ? +((values.amount - values.bonus_balance) * 100).toFixed(2)
        : +(values.amount * 100).toFixed(2),
      user: data.client_id || valuesData?.user,
      comment: values.comment,
      status_sending_mail: values.status_sending_mail,
      bonus_balance: +(values.bonus_balance * 100).toFixed(2),
    }

    // Если выбрана компания, то Локация обязательна
    data.valid = {
      amount: 'positive',
      ...(bo.company && { location: 'required' }),
    }
    changeValuesArray(bo, 'newData')
    // eslint-disable-next-line
  }, [values])

  useEffect(() => {
    if (data.isUnidance) {
      if (values.company) {
        superAxiosRequest({
          method: 'get',
          link: `db/companies/${values.company}`,
        }).then((res) => {
          setValues({ ...values, locations: res.data.locations })
        })
      }
    }
  }, [values.company])

  useEffect(() => {
    if (
      values.amount === 0 &&
      fetchedPriceSums?.length &&
      values?.price_sums !== 1
    ) {
      const selectedPriceSumAfterInitialFetch = fetchedPriceSums?.find(
        (el) => el?.id === values?.price_sums,
      )
      calculator(selectedPriceSumAfterInitialFetch, 'price_sums')
    }
  }, [values?.price_sums, fetchedPriceSums?.length])

  if (loading) return <Loader />

  return (
    <div className='modalAddPayment'>
      <GroupSelector
        onChange={changeGroup}
        groups={
          groupId && groupId !== undefined
            ? payData.groups?.filter((g) => g.id === groupId)
            : payData.groups || []
        }
        companies={payData.company_balances || []}
        value={values.student_group_rel || values.company}
      />
      {values.company && (
        <div className='modalAddPayment__field'>
          <p className='superModalGroup__label'>Выберите локацию:</p>
          <SelectCustom
            placeholder='Локация'
            options={
              data.isUnidance
                ? values.locations
                : payData.company_balances.find(
                    (x) => x.company.id === values.company,
                  ).company.locations
            }
            sortKey='name'
            valueID={values.location}
            onChange={(o) => {
              changeHandler(o.id, 'location')
            }}
            error={check('location')}
          />
        </div>
      )}
      {!isClient ? (
        <div className='modalAddPayment__row'>
          <div className='modalAddPayment__field'>
            <FormField>
              <FormLabel>Цена студента в группе:</FormLabel>
              <FormSelectCustom>
                <SelectCustom
                  placeholder='Цена в группе'
                  apiGetResult={getResultPriceSums}
                  apiLink='groups/price_sums'
                  valueID={values.price_sums}
                  apiConfParams={{ limit: 999 }}
                  getOptionLabel={(opt) =>
                    `${opt.name}  (${opt.price_sum}.00тг. за ${opt.hours_sum} ${opt.hours_type.id === 1 ? 'ак.ч.' : 'астр.ч.'})`
                  }
                  formatOptionLabel={formatOptionLabel}
                  sortKey='name'
                  onChange={(o) => calculator(o, 'price_sums')}
                  isSearchable
                />
              </FormSelectCustom>
            </FormField>
          </div>
          <div className='modalAddPayment__field'>
            <FormField>
              <FormLabel>Тип часов:</FormLabel>
              <FormSelectCustom>
                <SelectCustom
                  placeholder='Академические / Астрономические'
                  options={[
                    { id: 1, name: 'Академические' },
                    { id: 2, name: 'Астрономические' },
                  ]}
                  valueID={values.hourType}
                  onChange={(o) => calculator(o.id, 'hourType', 'int')}
                  isLoading={false}
                />
              </FormSelectCustom>
            </FormField>
          </div>

          <div className='modalAddPayment__field'>
            <FormField>
              <FormLabel>Количество часов:</FormLabel>
              <FormSelectCustom>
                <DummyCounter
                  name='hours'
                  value={values.hours}
                  onChange={calculator}
                  step={0.5}
                  min={0.5}
                  max={2000}
                  fixed={2}
                />
              </FormSelectCustom>
            </FormField>
          </div>
          <div className='modalAddPayment__field'>
            <FormField>
              <FormLabel>{loc(dict.pays.text_4)}:</FormLabel>
              <FormInput isError={check('amount')}>
                <input
                  placeholder='Сумма'
                  name='valueInput'
                  type='number'
                  value={values.amount}
                  onChange={(e) => calculator(+e.target.value, 'amount')}
                  className={
                    check('amount') ? 'super-modal__input--error' : undefined
                  }
                />
              </FormInput>
            </FormField>
          </div>
        </div>
      ) : (
        <div className='modalAddPayment__field'>
          <FormField>
            <FormLabel>{loc(dict.pays.text_4)}:</FormLabel>
            <FormInput isError={check('sum')}>
              <input
                placeholder='Сумма'
                name='valueInput'
                type='number'
                value={values.amount}
                onChange={(e) => calculator(+e.target.value, 'amount')}
                className={check('amount') ? 'super-modal__input--error' : ''}
              />
            </FormInput>
          </FormField>
        </div>
      )}

      {!isClient && (
        <>
          <div className='modalAddPayment__row'>
            <div className='modalAddPayment__field'>
              <FormDateSelector
                placeholder='Finish Date'
                label='Дата оплаты:'
                onChange={(date) =>
                  changeHandler(dateFormat(date, 'YYYY-mm-dd'), 'payment_date')
                }
                value={new Date(values?.payment_date)}
                error={check('date')}
              />
            </div>
            <div className='modalAddPayment__field'>
              <FormDateSelector
                placeholder='Start Date'
                label='Дата действия счета:'
                onChange={(date) =>
                  changeHandler(
                    dateFormat(date, 'YYYY-mm-dd'),
                    'payment_expires',
                  )
                }
                value={new Date(values?.payment_expires)}
                error={check('date')}
              />
            </div>
          </div>
          <div className='modalAddPayment__field'>
            <FormField>
              <FormLabel>Комментарий платежа:</FormLabel>
              <FormInput isError={check('comment')}>
                <textarea
                  value={values.comment}
                  onChange={({ target: { value } }) =>
                    changeHandler(value, 'comment')
                  }
                  className='placementTestBox__textarea'
                  placeholder='Комментарий'
                />
              </FormInput>
            </FormField>
          </div>
          <FormField>
            <ToggleCheckbox
              label={'Уведомить клиента о выставлении счёта'}
              checked={values.status_sending_mail === 'need_mail'}
              onChange={() =>
                changeHandler(
                  values.status_sending_mail === 'need_mail'
                    ? 'not_mail'
                    : 'need_mail',
                  'status_sending_mail',
                )
              }
            />
          </FormField>
        </>
      )}
    </div>
  )
}

export default observer(AddPayment)
